<template>
  <div class="about-page">
    <div class="about-page__container">
      <div class="about-page__row">
        <div v-if="showDynamicMenu" class="floating-menu">
          <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
        </div>
        <div class="about-page__column">
        <div class="about-page__title"><h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">О центре</h1></div>
        <div class="about-page__img">
          <img src="../../assets/img/dar-image-2.jpeg" alt="О центре">
        </div>
        </div>
      </div>
      <div class="about-page-preview__title">
        <AppLottieDar/>
      </div>
      <div class="about-page-preview">
        <div class="about-page-preview__subtitle">
          <p class="text-circe-bold-24 color-gray">Дети. Алтай. Россия</p>
        </div>
        <div class="about-page-preview__text">
          <p class="text-circe-20-36">Эти главные и определяющие слова вынесены в название перинатального центра, ставшего одним из ключевых звеньев в медицинском кластере Алтайского края. В настоящее время «ДАР» представляет собой законченный цикл медицинских технологий, начиная с планирования беременности, ее вынашивания, родоразрешения и завершая выхаживанием ребенка до тех пор, пока мама и малыш не будут готовы к выписке.Сегодня «ДАР» обеспечивает доступ к здравоохранению суперсовременного уровня на самом значимом направлении – родовспоможении – всем женщинам края и других регионов.Приоритетным направлением работы перинатального центра является оказание квалифицированной помощи беременным женщинам, отнесенным к группам повышенного риска возникновения перинатальной патологии, ведение родовой деятельности. Использование высоких технологий неонатологической помощи центра позволяет выхаживать недоношенных детей с экстремально низкой массой тела от 500 граммов. История центра началась с открытия в декабре 2016 года, именно с этого момента возможность стать мамой появилась даже у тех женщин региона, кто раньше об этом статусе только мечтал.</p>
        </div>
      </div>
      <div class="about-page-values">
        <div class="about-page-values__title">
          <p class="text-TTDrugs-Bold-40 color-green">Наши ценности</p>
        </div>
        <div class="info-block-with-title__grid">
          <div class="info-block-with-title">
            <div class="info-block-with-title__header">
              <p class="text-TTDrugs-bold-24 color-white">
                ПАЦИЕНТЫ
              </p>
            </div>
            <div class="info-block-with-title__img">
              <img src="../../assets/svg/patient-protection.svg" alt="Пациенты">
            </div>
            <div class="info-block-with-title__text">
              <p class="text-circe-16 center">Мы действуем в интересах каждого пациента. Жизнь человека, его счастье и благополучие, уверенность в завтрашнем дне - главное для каждого нашего сотрудника</p>
            </div>
          </div>
          <div class="info-block-with-title">
            <div class="info-block-with-title__header">
              <p class="text-TTDrugs-bold-24 color-white">
                ПРОФЕССИОНАЛИЗМ
              </p>
            </div>
            <div class="info-block-with-title__img">
              <img src="../../assets/svg/doctor.svg" alt="Доктор">
            </div>
            <div class="info-block-with-title__text">
              <p class="text-circe-16 center">Каждый наш специалист - профессионал в своем деле, постоянно совершенствующий свои знания и навыки, рабочие процессы и личные качества</p>
            </div>
          </div>
          <div class="info-block-with-title">
            <div class="info-block-with-title__header">
              <p class="text-TTDrugs-bold-24 color-white">
                ПРЕЕМСТВЕННОСТЬ
              </p>
            </div>
            <div class="info-block-with-title__img">
              <img src="../../assets/svg/diagnosing.svg" alt="Преемственность">
            </div>
            <div class="info-block-with-title__text">
              <p class="text-circe-16 center">Каждая программа диагностики, лечения, реабилитации создается при взаимодействии целой команды специалистов, каждый из которых учитывает все особенности пациента для достижения лучших результатов</p>
            </div>
          </div>
          <div class="info-block-with-title">
            <div class="info-block-with-title__header">
              <p class="text-TTDrugs-bold-24 color-white">
                ПРОГРЕСС
              </p>
            </div>
            <div class="info-block-with-title__img">
              <img src="../../assets/svg/employee-progress.svg" alt="Прогресс">
            </div>
            <div class="info-block-with-title__text">
              <p class="text-circe-16 center">Мы - команда, которая доверяет друг другу. Нас объединяют цели и желание развиваться на основе достижений современной науки</p>
            </div>
          </div>
        </div>

      </div>
      <div class="about-page-history">
        <div class="about-page-history__title">
          <p class="text-TTDrugs-Bold-40 color-green">История перинатального центра </p>
        </div>
        <AppSwiperHistory/>
      </div>
    </div>
  </div>
</template>

<script>
import AppSwiperHistory from '@/components/Gallery/SwiperHistory.vue'
import AppLottieDar from '@/components/Lottie/LottieDar.vue'
import DynamicMenu from "@/components/DynamicMenu.vue";
import menuItemsApi from "@/api/menuItems";

export default {
    name: "AppArticleDetail",
    components: {DynamicMenu, AppLottieDar, AppSwiperHistory},
    data() {
      return {
        dynamicMenuItems: [],
        linksDepartment: 'about',
      }
    },
    metaInfo() {
      return {
        title: 'О центре | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Подробная информация о Алтайском краевом клиническом перинатальном центре ДАР. Узнайте о наших ценностях и истории центра.'
          },
          {
            name: 'keywords',
            content: 'о центре, история, Алтайский краевой клинический перинатальный центр'
          }
        ]
      };
    },
    methods: {
      async loadSiblingsForMenu() {
        try {
          const response = await menuItemsApi.getSiblingsByTo('/about');

          if (response.data.status === "SUCCESS") {
            this.dynamicMenuItems = response.data.result
                .map(item => {
                  const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

                  return {
                    text: item.label,
                    link: item.to,
                    slug: slug,
                    active: slug === this.currentPath,
                    id: item.id,
                    order: item.order || 0
                  };
                })
                .sort((a, b) => (a.order || 0) - (b.order || 0));
          }
        } catch (error) {
          console.error('Ошибка при загрузке меню:', error);
        }
      }
    },
    computed: {
      showDynamicMenu() {
        return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
      }
    },
    mounted() {
      this.loadSiblingsForMenu();
    }
  };
</script>

<style scoped>

</style>
